import React from 'react';
import PropTypes from 'prop-types';
import HeaderTypography from 'components/Common/HeaderTypography';
import AddIcon from '@material-ui/icons/Add';
import ClickableDiv from 'components/Common/ClickableDiv';
import Styles from './index.module.css';

function NewMarketCard({
  onClick,
}) {
  return (
    <ClickableDiv
      className={Styles.container}
      onClick={onClick}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
        }}
      >
        <AddIcon style={{ color: '#455780' }} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
        }}
      >
        <HeaderTypography>
          新增賣場
        </HeaderTypography>
      </div>
    </ClickableDiv>
  );
}

NewMarketCard.propTypes = {
  onClick: PropTypes.func,
};

NewMarketCard.defaultProps = {
  onClick: () => {},
};

export default NewMarketCard;
